import React, { useEffect, useState } from 'react';
import { getThemeBrand } from '@/shared/hooks/useBrandTheme';
import { BannerImage, Picture } from './styles';

interface ResponsiveBannerImageProps {
  desktopSrc: string;
  mobileSrc?: string;
  alt: string;
  className?: string;
  fetchPriority?: 'high' | 'low' | 'auto';
  loading?: 'eager' | 'lazy';
}

const ResponsiveBannerImage = ({
  desktopSrc,
  mobileSrc,
  alt,
  className,
  fetchPriority,
  loading = 'eager',
}: ResponsiveBannerImageProps) => {
  const [hasError, setHasError] = useState(false);
  const loader = getThemeBrand().assets.loader;

  useEffect(() => {
    setHasError(false);
  }, [desktopSrc, mobileSrc]);

  if (hasError) {
    return (
      <Picture className={className}>
        {loader?.mobile && (
          <source media="(max-width: 768px)" srcSet={loader.mobile} />
        )}
        <BannerImage
          src={loader?.default}
          alt={alt}
          loading={loading}
          fetchPriority={fetchPriority}
          decoding="async"
        />
      </Picture>
    );
  }

  return (
    <Picture className={className}>
      {mobileSrc && <source media="(max-width: 768px)" srcSet={mobileSrc} />}
      <BannerImage
        src={desktopSrc}
        alt={alt}
        loading={loading}
        fetchPriority={fetchPriority}
        decoding="async"
        onError={() => setHasError(true)}
      />
    </Picture>
  );
};

export { ResponsiveBannerImage };
